<template>
	<base-modal :show="!!error" title="An error occurred" @close="handleError">
		<p>{{ error }}</p>
	</base-modal>
	<!-- <h1 class="text-info mb-5">
		<i :class="{ 'fa-beat': iconChange }" class="fa-solid fa-circle-user text-info"></i>
		Login
	</h1> -->
	<form @submit.prevent="submitSignInForm">
		<div class="form-floating mb-3" :class="{ invalid: !loginEmail.isValid }">
			<input
				type="email"
				class="form-control"
				id="loginEmail"
				placeholder="name@example.com"
				v-model.trim="loginEmail.val"
				@blur="clearValidity('loginEmail')"
				@change="animateIcon"
			/>
			<label for="floatingInput">Email address</label>
			<small class="form-text text-muted mb-4" v-if="!loginEmail.isValid"> Please enter a valid email! </small>
		</div>
		<div class="form-floating" :class="{ invalid: !loginPassword.isValid }">
			<input
				type="password"
				class="form-control"
				id="loginPassword"
				placeholder="Password"
				v-model.trim="loginPassword.val"
				@blur="clearValidity('loginPassword')"
			/>
			<label for="floatingPassword">Password</label>
			<small class="form-text text-muted mb-4" v-if="!loginPassword.isValid"> Invalid password! </small>
		</div>
		<div class="mt-2">
			<button type="submit" class="btn btn-outline-info mt-4" :disabled="isLoading">
				<span v-show="!isLoading"> Login </span>
				<div v-show="isLoading">
					<i class="fa-solid fa-baseball fa-spin"></i>
					Logging in...
				</div>
			</button>
		</div>
	</form>
</template>

<script>
export default {
	emits: ['showLoginForm', 'component-key'],
	data() {
		return {
			loginEmail: {
				val: '',
				isValid: true,
			},
			loginPassword: {
				val: '',
				isValid: true,
			},
			formIsValid: true,
			error: null,
			isLoading: false,
			iconChange: false,
		};
	},
	methods: {
		animateIcon() {
			this.iconChange = true;
		},
		validateForm() {
			if (this.loginEmail.val === '') {
				this.loginEmail.isValid = false;
				this.formIsValid = false;
			}
			if (this.loginPassword.val === '' || this.loginPassword.val.length < 6) {
				this.loginPassword.isValid = false;
				this.formIsValid = false;
			}
		},
		clearValidity(input) {
			this[input].isValid = true;
		},
		async submitSignInForm() {
			this.validateForm();
			if (!this.formIsValid) {
				return;
			}

			const payload = {
				email: this.loginEmail.val,
				password: this.loginPassword.val,
			};
			try {
				this.isLoading = true;
				await this.$store.dispatch('signIn', payload);
				this.getUserData();
				this.loadNotifications()
				setTimeout(() => {
					this.$emit('showLoginForm', { value: false });
				}, 1000);
			} catch (err) {
				this.error = err.message || 'Sign In failed... Try again.';
			}
			setTimeout(() => {
				this.isLoading = false;
			}, 1000);
			this.$emit('component-key', {});
		},
		async getUserData() {
			await this.$store.dispatch('fetchUserData');
		},
		async loadNotifications() {
			try {
				await this.$store.dispatch('notifications/fetchNotifications');
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
		},
		handleError() {
			this.error = null;
		},
	},
};
</script>

<style scoped>
.md-form label.active {
	color: #39c0ed !important;
}
.md-form input {
	color: #39c0ed !important;
}
.md-form input:focus {
	border-bottom: 0.5px solid #39c0ed !important;
	box-shadow: 0 1px 0 0 #39c0ed !important;
	color: #39c0ed !important;
}

.invalid label {
	color: red;
}

.invalid input {
	border: 1px solid red;
}
</style>
